import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment'; 
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  apiURL = environment.BACKEND_URL; 

  getUserCertificate(id: string): Observable<any>{
    return this.http.get(`${this.apiURL}/certificates/${id}`); 
  }
  getUserCertificateKeyRotation(id: string): Observable<any>{
    return this.http.get(`${this.apiURL}/certificates/${id}/rotate-keys`); 
  }

  downloadDigiCertCertificate(certificateId: string, formatType: string = 'default_cer'): Observable<Blob> {
    const token = this.authService.getToken();
    if (!token) {
      throw new Error("User is not authenticated");
    }
 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
 
    return this.http.get(`${this.apiURL}/ai-functions/download-certificate?certificateId=${certificateId}&formatType=${formatType}`, {
      headers,
      responseType: 'blob'
    });
  }

  
  getAllCertificates(): Observable <any>{
    const token = this.authService.getToken();
    if(!token){
      throw new Error("User is not authenticated");
    } 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })

    return this.http.get(`${this.apiURL}/certificates`, { headers }); 
  }

  addCertificate(certificateData: any): Observable<any>{
    const token = this.authService.getToken(); 
    if(!token){
      throw new Error("User is not authenticated");
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })

    return this.http.post(`${this.apiURL}/certificates`, certificateData, {
      headers,
    });  
  }

  // getSSLDetails(domain: string): Observable<any> {
  //   if (!domain) {
  //     throw new Error('Domain is required');
  //   }

  //   return this.http.post(`${this.apiURL}/ssl-details`, { domain });
  // }

  // updatecertificate(id:string, certificateData: any): Observable<any>{
  //   return this.http.put(`${this.apiURL}${id}`, certificateData); 
  // }

  // deleteCertificate(id: string): Observable<any>{
  //   return this.http.delete(`${this.apiURL}${id}`); 
  // }

  // we are sending the domain name as body to the backend
  getdownloadCertificate(domain: string): Observable<any> {
    return this.http.post(`${this.apiURL}/ssl-chat/upload-fullchain`, { domain });
  }
}
